

export const state = {
    ws: [],

    wsLoading: false,
    wsCreating: { status: false, data: {} },

    // Map of stationId -> boolean loading state for deletes
    wsDeleting: {},

    viewWsLayer: false,
    viewWeatherStationManager: false,
};